import React, { useState } from "react";
import { SubscribeButton } from "./SubscribeButton";
import { SubscriptionType } from "./types/SubscriptionTypes";
import './styles/SubscriptionOptions.css';

interface SubscriptionOptionsProps {
  email: string;
}

export const SubscriptionOptions: React.FC<SubscriptionOptionsProps> = ({ email }) => {
  const [showOptions, setShowOptions] = useState(false);

  const showOptionsHandler = () => {
    setShowOptions(true);
  };

  const hideOptionsHandler = () => {
    setShowOptions(false);
  };

  return (
    <div className="subscription-card">
      <div className={`subscription-card__inner ${showOptions ? "is-flipped" : ""}`}>
        {/* Front side */}
        <div className="subscription-card__face subscription-card__face--front">
          <button
            onClick={showOptionsHandler}
            className="btn create-btn w-50 w-lg-auto"
          >
            Subscribe
          </button>
        </div>

        {/* Back side */}
        <div className="subscription-card__face subscription-card__face--back">
          <div className="subscription-options">
            <SubscribeButton
              email={email}
              subscriptionType={SubscriptionType.FREE}
              onIgnore={hideOptionsHandler}
            />
            <SubscribeButton
              email={email}
              subscriptionType={SubscriptionType.MONTHLY}
            />
            <SubscribeButton
              email={email}
              subscriptionType={SubscriptionType.ANNUAL}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
